import { render, staticRenderFns } from "./receiveOrders.pug?vue&type=template&id=084a3e2f&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./receiveOrders.scss?vue&type=style&index=0&id=084a3e2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a3e2f",
  null
  
)

export default component.exports